/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.64
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import DeletedItemDTO from './DeletedItemDTO';
import PageableObject from './PageableObject';
import SortObject from './SortObject';

/**
 * The PageDeletedItemDTO model module.
 * @module model/PageDeletedItemDTO
 * @version 1.0.1
 */
export default class PageDeletedItemDTO {
  /**
   * Constructs a new <code>PageDeletedItemDTO</code>.
   * @alias module:model/PageDeletedItemDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PageDeletedItemDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PageDeletedItemDTO} obj Optional instance to populate.
   * @return {module:model/PageDeletedItemDTO} The populated <code>PageDeletedItemDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PageDeletedItemDTO();
      if (data.hasOwnProperty('totalElements'))
        obj.totalElements = ApiClient.convertToType(data['totalElements'], 'Number');
      if (data.hasOwnProperty('totalPages'))
        obj.totalPages = ApiClient.convertToType(data['totalPages'], 'Number');
      if (data.hasOwnProperty('size'))
        obj.size = ApiClient.convertToType(data['size'], 'Number');
      if (data.hasOwnProperty('content'))
        obj.content = ApiClient.convertToType(data['content'], [DeletedItemDTO]);
      if (data.hasOwnProperty('number'))
        obj._number = ApiClient.convertToType(data['number'], 'Number');
      if (data.hasOwnProperty('sort'))
        obj.sort = SortObject.constructFromObject(data['sort']);
      if (data.hasOwnProperty('first'))
        obj.first = ApiClient.convertToType(data['first'], 'Boolean');
      if (data.hasOwnProperty('last'))
        obj.last = ApiClient.convertToType(data['last'], 'Boolean');
      if (data.hasOwnProperty('numberOfElements'))
        obj.numberOfElements = ApiClient.convertToType(data['numberOfElements'], 'Number');
      if (data.hasOwnProperty('pageable'))
        obj.pageable = PageableObject.constructFromObject(data['pageable']);
      if (data.hasOwnProperty('empty'))
        obj.empty = ApiClient.convertToType(data['empty'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} totalElements
 */
PageDeletedItemDTO.prototype.totalElements = undefined;

/**
 * @member {Number} totalPages
 */
PageDeletedItemDTO.prototype.totalPages = undefined;

/**
 * @member {Number} size
 */
PageDeletedItemDTO.prototype.size = undefined;

/**
 * @member {Array.<module:model/DeletedItemDTO>} content
 */
PageDeletedItemDTO.prototype.content = undefined;

/**
 * @member {Number} _number
 */
PageDeletedItemDTO.prototype._number = undefined;

/**
 * @member {module:model/SortObject} sort
 */
PageDeletedItemDTO.prototype.sort = undefined;

/**
 * @member {Boolean} first
 */
PageDeletedItemDTO.prototype.first = undefined;

/**
 * @member {Boolean} last
 */
PageDeletedItemDTO.prototype.last = undefined;

/**
 * @member {Number} numberOfElements
 */
PageDeletedItemDTO.prototype.numberOfElements = undefined;

/**
 * @member {module:model/PageableObject} pageable
 */
PageDeletedItemDTO.prototype.pageable = undefined;

/**
 * @member {Boolean} empty
 */
PageDeletedItemDTO.prototype.empty = undefined;

